import { render } from "./PaymentWarningModal.vue?vue&type=template&id=fa925168&scoped=true"
import script from "./PaymentWarningModal.vue?vue&type=script&lang=js"
export * from "./PaymentWarningModal.vue?vue&type=script&lang=js"

import "./PaymentWarningModal.vue?vue&type=style&index=0&id=fa925168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa925168"]])

export default __exports__